function RecommendedVisits({ visits }) {
  return (
    <section className="recommended-section">
      <h2>زيارات موصى بها</h2>
      <p className="section-subtitle">
        شركات إضافية للزيارة عند توفر الوقت — ليست مضمنة في الجدول المحدد (12 زيارة كحد أقصى).
      </p>
      <div className="recommended-grid">
        {visits.map((visit) => (
          <article key={visit.name} className="recommended-card">
            <div className="recommended-header">
              <h3>{visit.name}</h3>
              {visit.suggestedDay && (
                <span className="suggested-day">{visit.suggestedDay}</span>
              )}
            </div>
            {visit.location && (
              <p className="recommended-location">{visit.location}</p>
            )}
            {visit.notes && (
              <p className="recommended-notes">{visit.notes}</p>
            )}
          </article>
        ))}
      </div>
    </section>
  );
}

export default RecommendedVisits;
